<template>
    <b-form-group
        :label="titulo"
    >
        <input 
            type="text"
            class="form-control form-control-sm" 
            :placeholder="texto"
            v-mask="mask"
            v-model="valorReal"
            v-on:input="handleInput"
        >
        
        <slot></slot>
    </b-form-group>
</template>
<script>
    import createNumberMask from 'text-mask-addons/dist/createNumberMask';
    const mascaraDinheiro = createNumberMask({
        prefix: 'R$ ',
        allowDecimal: true,
        includeThousandsSeparator: true,
        allowNegative: false,
        thousandsSeparatorSymbol: '.',
        allowDecimal: true,
        decimalSymbol: ','
    })
    export default {
        name: 'inputMoeda',
        data(){
            return {
                mask: mascaraDinheiro,
                valorReal: this.value
            }
        },
        props: {
            value: {
                required: false
            },
            texto: {
                required: true,
                type: String
            },
            titulo: {
                required: true,
                type: String
            }
        },

        methods: {
            handleInput: function(e){
                let valor = this.valorReal
                valor = valor.slice(3)
                valor = valor.replace(/\./gi, '')

                this.$emit('input', valor)
            }
        }
    }
</script>